<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>WORKSHOPS</p>
      </div>
    </div>
    <div class="main-container">
      <div class="content-item-grp" v-show="false">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">WORKSHOPS</span>
          </div>
          <div class="item-content">
            <p class="content-null-info">敬请期待......</p>
          </div>
        </div>
      </div>
      <div class="content-item-grp" v-show='false'>
        <div class="content-item" v-for="(workshop,index) in this.$dicts.workshopList" :key="index">
          <div class="item-title">
            <span class="item-title-content">
              <!-- {{index+1}}. {{workshop.title}} -->
              <div class="">W{{index+1}}：{{workshop.title}}</div>
              <!-- <div class="item-title-label">（按报告顺序排列）</div> -->
<span class="item-title-label">
                <el-button type="text" @click="seeDetails(index)">点击查看详情</el-button>
              </span>
            </span>
          </div>
          <!-- <template v-if="index==18">
          <div >
            <img style="width:100%;" src="static/images/workshop/xueshengluntan.png">
          </div>
            
            </template> -->

          <div class="item-content" v-show="true">
            <div class="workshop-item">
              <!-- <div class="workshop-info-label">
                <div>组织者：</div>
                  <div class="organizer-contain" v-for="organizer in workshop.organizers">
                    {{organizer.name}}
                    <template v-if="organizer.unit!= ''">
                      （{{organizer.unit}}）
                    </template>
                </div>
              </div> -->
              <!-- <div class="workshop-info-label">时间：<span class="text-red">{{workshop.time}}</span> </div>
              <div class="workshop-info-label">讲者：</div> -->
            <div style="margin-top: 16px;">{{workshop.content }}</div>
           
            <div style="text-align: left;color: blue; font-weight: bolder;">组织者</div>
              <div class="workshop-speaker-contain">
                <a
                  class="workshop-speaker"
                  v-for="(organizer, organizerIndex) in workshop.organizers"
                  :key="organizerIndex"
                  :target="organizer.homepage ? '_blank' : null"
                  :href="organizer.homepage ? organizer.homepage : null"
                >
                  <div class="speaker-image" :style="{'background-image':'url('+organizer.image+')'}"></div>
                  <div class="workshop-speaker-label-info speaker-name">{{organizer.name}}</div>
                  <div class="workshop-speaker-label-info speaker-org">{{organizer.unit}}</div>
                </a>
                <!-- <template  v-for="speaker in workshop.speakers">

                {{speaker.name}}（{{speaker.unit}}）、
              </template> -->

              </div>
            </div>
            <div style="text-align: left;color: blue; font-weight: bolder;">讲者</div>
              <div class="workshop-speaker-contain">
                <a
                  class="workshop-speaker"
                  v-for="(speaker, speakerIndex) in workshop.speakers"
                  :key="speakerIndex"
                  :target="speaker.homepage ? '_blank' : null"
                  :href="speaker.homepage ? speaker.homepage : null"
                >
                  <div class="speaker-image" :style="{'background-image':'url('+speaker.image+')'}"></div>
                  <div class="workshop-speaker-label-info speaker-name">{{speaker.name}}</div>
                  <div class="workshop-speaker-label-info speaker-org">{{speaker.unit}}</div>
                </a>
            </div>


          </div>
        </div>
      </div>
      <div class="content-item-grp" v-show="true">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">Workshop 列表</span>
          </div>
          <div class="item-content workshop-schedule-overview">
            <!-- <p class="schedule-overview-note">以下与「大会程序」页面日程一致；Tutorial 场次请见大会程序。</p> -->

            <div class="item-content-title">5月9日（星期六）</div>
            <p class="parallel-hint"><span class="text-black-border">08:30-12:00</span> Workshop（以下并行举行）</p>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 1：VLA</div>
                <div class="parallel-meta">组织者：刘敏（湖南大学），穆尧（上海交通大学），仉尚航（北京大学），石恒璨（湖南大学），张杰（中国科学院计算技术研究所）</div>
                <div class="parallel-meta">讲者：宋井宽 (同济大学)，任文琦 (中山大学)，叶茫 (武汉大学)，于超 (清华大学)，黄青虬 (墨奇智能 & 武汉大学)，翟少鹏 (上海人工智能实验室)</div>
                <div class="parallel-meta">Panel嘉宾：宋井宽（同济大学）、任文琦（中山大学）、叶茫（武汉大学）、于超（清华大学）、翟少鹏（上海人工智能实验室）、黄青虬（墨奇智能 & 武汉大学）、苏航（清华大学）、张力（复旦大学）、马道林（上海交通大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉卷厅</div>

              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 2：智能推理：视觉推理、科学推理</div>
                <div class="parallel-meta">组织者：董胤蓬（清华大学），苏航（清华大学），山世光（中国科学院计算技术研究所），邓志杰（上海交通大学）</div>
                <div class="parallel-meta">讲者：国雍 (华为)，黄高 (清华大学)，桂韬（复旦大学），邓志杰 (上海交通大学)，王欢 (西湖大学)</div>
                <div class="parallel-meta">Panel嘉宾：黄高（清华大学）、桂韬（复旦大学）、邓志杰（上海交通大学）、王欢（西湖大学）、国雍（华为）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉星厅</div>

              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 3：大语言模型与人机交互</div>
                <div class="parallel-meta">组织者：户保田（哈尔滨工业大学（深圳））</div>
                <div class="parallel-meta">讲者：邱锡鹏（复旦大学），东昱晓 (清华大学)，徐进 (阿里巴巴)，林洲汉 (上海交通大学)，陈谐 (上海交通大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉琴厅</div>

              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 4：AI4Science</div>
                <div class="parallel-meta">组织者：杨易（浙江大学），范鹤鹤（浙江大学），唐彦嵩（清华大学），黄强（哈尔滨工业大学（深圳）），王韫博（上海交通大学）</div>
                <div class="parallel-meta">讲者：严骏驰 (上海交通大学)，白琮 (浙江工业大学)，袁亚飞 (清华大学)，荣钰 (阿里巴巴达摩院)，魏颖 (浙江大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江穆厅</div>

              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 5：未来终端影像技术</div>
                <div class="parallel-meta">组织者：程明明（南开大学)，卢湖川（大连理工大学），王立君（大连理工大学），郭春乐（南开大学）高广谓（南京理工大学）</div>
                <div class="parallel-meta">讲者：潘金山 (南京理工大学)，顾舒航 (电子科技大学)，王立志 (北京师范大学)，夏靖远 (国防科技大学)，张志路 (哈尔滨工业大学)</div>
                <div class="parallel-meta">Panel嘉宾：张磊（香港理工大学）、左旺孟（哈尔滨工业大学）、潘金山（南京理工大学）、顾舒航（电子科技大学）、王立志（北京师范大学）、夏靖远（国防科技大学）、张志路（哈尔滨工业大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江耀厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 6：神经符号智能</div>
                <div class="parallel-meta">组织者：戴望州（南京大学），丁尧相（浙江大学），郭兰哲（南京大学），黎铭（南京大学）</div>
                <div class="parallel-meta">讲者：杨博 (吉林大学)，况琨 (浙江大学)，朱毅鑫 (北京大学)，李昊轩 (北京大学)，Haiyan Yin (新加坡A*)，丁尧相（浙江大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江海厅</div>
              </div>

            <p class="parallel-hint"><span class="text-black-border">12:00-13:30</span> Poster (5F汉清厅&汉翔厅) / 午餐(3F)</p>

            <p class="parallel-hint"><span class="text-black-border">13:30-17:00</span> Workshop（以下并行举行）</p>
            <div class="parallel-list">
              <div class="parallel-item">
                <div class="parallel-name">Workshop 7：视频生成技术</div>
                <div class="parallel-meta">组织者：高常鑫（华中科技大学），袁粒（北京大学），武宇（武汉大学）</div>
                <div class="parallel-meta">讲者：储瑞航（阿里巴巴），朱政 (极佳科技)，吴祖煊 (复旦大学)，何声一（百度）、侯淇彬 (南开大学)、齐晓娟（香港大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉卷厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 8：可信智能与AI安全</div>
                <div class="parallel-meta">组织者：王骞（武汉大学），沈超（西安交通大学），魏云超（北京交通大学）</div>
                <div class="parallel-meta">讲者：张阳 (德国亥姆霍兹信息安全中心)，刘安安 (天津大学)，温正琪 (清华大学)，秦湛 (浙江大学)，李政 (山东大学)，何新磊 (武汉大学)，杨乐 (西安交通大学)，刘卓然 (荷兰拉德堡德大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉星厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 9：文档图像智能</div>
                <div class="parallel-meta">组织者：刘禹良（华中科技大学）、周宇（南开大学）、白翔（华中科技大学）</div>
                <div class="parallel-meta">讲者：陈智能 (复旦大学)，何聪辉 (上海人工智能实验室)，刘毅 (百度)，付彬 (中国科学院深圳先进技术研究院)，刘强 (金山办公)，陈伟 (华中科技大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉琴厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 4：AI4Science</div>
                <div class="parallel-meta">组织者：杨易（浙江大学），范鹤鹤（浙江大学），唐彦嵩（清华大学），黄强（哈尔滨工业大学（深圳）），王韫博（上海交通大学）</div>
                <div class="parallel-meta">讲者：许岩岩 (上海交通大学)，王韫博 (上海交通大学)，吴泰霖 (西湖大学)，全睿杰 (浙江大学)，林森林 (哈尔滨工业大学 (深圳))</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江穆厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 10：视觉质量评测与后训练强化学习</div>
                <div class="parallel-meta">组织者：刘笑宏（上海交通大学），马柯德（香港城市大学），赵铁松（福州大学）</div>
                <div class="parallel-meta">讲者：张磊 (香港理工大学)，李雷达 (西安电子科技大学)，陈启峰 (香港科技大学)，赵世杰 (字节跳动)，张子澄 (上海人工智能实验室)</div>
                <div class="parallel-meta">Panel嘉宾：张磊（香港理工大学）、李雷达（西安电子科技大学）、陈启峰（香港科技大学）、赵世杰（字节跳动）、张子澄（上海人工智能实验室）、刘笑宏（上海交通大学）、赵铁松（福州大学）、董超（中国科学院深圳先进技术研究院）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江耀厅</div>
              </div>

              <div class="parallel-item">
                <div class="parallel-name">Workshop 11：机器学习理论与优化</div>
                <div class="parallel-meta">组织者：刘日升（大连理工大学），林宙辰（北京大学）</div>
                <div class="parallel-meta">讲者：张兴义 (安徽大学)，刘新旺 (国防科技大学)，葛冬冬 (上海交通大学)，李武军 (南京大学)，孙若愚 (香港中文大学 (深圳))，王奕森 (北京大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江海厅</div>
              </div>
            </div>

            <div class="item-content-title">5月10日（星期日）</div>
            <p class="parallel-hint"><span class="text-black-border">08:30-12:00</span> Workshop（以下并行举行）</p>
            <div class="parallel-list">
              <div class="parallel-item">
                <div class="parallel-name">Workshop 12：世界模型</div>
                <div class="parallel-meta">组织者：阚美娜（中国科学院计算技术研究所），张兆翔（中国科学院自动化研究所），鲁继文（清华大学）</div>
                <div class="parallel-meta">讲者：兰旭光 (西安交通大学)，徐凯 (中科院工业人工智能研究所)，段岳圻 (清华大学)，靳潇杰 (北京交通大学)，王韫博 (上海交通大学)，范略 (中科院自动化所)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉旗厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 13：多模态大模型</div>
                <div class="parallel-meta">组织者：刘勇（中国人民大学），王文海（香港中文大学），彭宇新（北京大学）</div>
                <div class="parallel-meta">讲者：彭宇新 (北京大学)，魏秀参 (东南大学)，李亮 (中国科学院计算技术研究所)，黄雷 (北京航空航天大学)，元玉慧 (canvas中国)，李晓彤（美团）</div>
                <div class="parallel-meta">Panel嘉宾：彭宇新（北京大学）、李亮（中国科学院计算技术研究所）、魏秀参（东南大学）、黄雷（北京航空航天大学）、元玉慧（canvas中国）、李晓彤（美团）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉卷厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 14：遥感解译</div>
                <div class="parallel-meta">组织者：夏桂松（武汉大学），张洪艳（中国地质大学（武汉）），孙显（中国科学院空天信息创新研究院）</div>
                <div class="parallel-meta">讲者：刘瑜 (清华大学)，任超 (中国科学院空天信息创新研究院)，康旭东 (湖南大学)，史振威 (北京航空航天大学)，刘天竹 (哈尔滨工业大学)，余磊 (武汉大学)，谢卫莹 (西安电子科技大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉星厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 15：多模态学习助力智慧医疗：从科研到落地</div>
                <div class="parallel-meta">组织者：许永超（武汉大学）、王妍（华东师范大学）、雷柏英（深圳大学）</div>
                <div class="parallel-meta">讲者：刘贤明 (哈尔滨工业大学)，李震 (华中科技大学同济医院)，谢伟迪（上海交通大学）、肖洒（中国科学院精密测量院）、檀韬 (澳门理工大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉琴厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 16：优秀学生论坛</div>
                <div class="parallel-meta">组织者：韩晓光（香港中文大学（深圳））、李翔（南开大学）、彭思达（浙江大学）、李贤芝（华中科技大学）</div>
                <div class="parallel-meta">讲者：陈铮 (上海交通大学)，余济闻 (香港大学)，张亦弛 (清华大学)，杨佳智 (香港中文大学)，李春一 (南洋理工大学)，胡腾 (上海交通大学)，陈麒光 (哈尔滨工业大学)，陈翔 (南京理工大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江天厅 </div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 17：持续学习与持续智能体</div>
                <div class="parallel-meta">组织者：谢源（上海创智学院），刘夏雷（南开大学），张志忠（华东师范大学）</div>
                <div class="parallel-meta">讲者：徐常胜 (中国科学院自动化研究所)，苏劲松 (厦门大学)，张煦尧 (中国科学院自动化研究所)，王立元 (清华大学)，杨若峰 (上海交通大学)，候臣平 (国防科技大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江穆厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 18：自动驾驶</div>
                <div class="parallel-meta">组织者：赵恒爽（香港大学），马超（上海交通大学），王兴刚（华中科技大学）</div>
                <div class="parallel-meta">讲者：张力 (复旦大学)，秦通 (上海交通大学)，苏鹏 (华为)，蒋理 (香港中文大学(深圳))，金鑫 (宁波东方理工大学)，梁定康 (华中科技大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江耀厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 19：三维视觉与空间智能</div>
                <div class="parallel-meta">组织者：郭裕兰（中山大学）、崔兆鹏（浙江大学）、王龙光（中山大学）</div>
                <div class="parallel-meta">讲者：周晓巍 (浙江大学)，雷印杰 (四川大学)，杨欣 (华中科技大学)，王冰 (香港理工大学)，董震 (武汉大学)，徐旦 (香港科技大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江海厅</div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Workshop",
        data() {
          return {
            activeNames: ['1','2','3','4'],
            collapseItemOpen:true
          }
        },
        methods: {
          handleChange(val) {
            console.log(val);
          },
          seeDetails(index){
            this.$router.push({name:"WorkshopItem",query: { id: index }});
          }
        }
    }
</script>

<style scoped>
  .program_banner{
    background-image: url("../../static/images/sub_banner/06.jpg");
  }
  .footer{
    /* position: fixed; */
    bottom: 0;
  }
  .workshop-item{
    text-align: left;
    padding: 0 16px;
  }
  .workshop-item .workshop-title{
    font-size: 16px;
    color: #0053a1;
    font-weight: 700;
    /*border-left: 1px solid #0053a1;*/
  }
  .workshop-item .workshop-info-label{
    font-size: 16px;
    color: #2c3e50;
    font-weight: 500;
    /*padding: 0 24px;*/
    margin: 8px 0;
  }
  .workshop-item .organizer-contain{
    margin-left: 50px;
  }
  .workshop-speaker-contain{
    display: flex;
    flex-wrap: wrap;
    flex-direction:row;
    /* justify-content:flex-start ; */
    justify-content:center;
    align-items:stretch;
    align-content:flex-start;
    padding: 0 24px;
  }
  .workshop-speaker-contain .workshop-speaker{
    width: 140px;
    /*height: 200px;*/
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #409EFF;
    border-bottom: 2px solid #FFF;
    margin: 8px;
  }
  .workshop-speaker-contain .workshop-speaker:hover{
    cursor: pointer;
    border-bottom: 2px solid #0053a1;
    /*border-radius: 8px;*/
    color: #0053a1;
  }
  .workshop-speaker-contain .workshop-speaker img{
    width: 112px;
    margin: 0 auto;
    border-radius: 56px;
    border: 1px solid #909399;

    /*height: 100%;*/
  }
  .workshop-speaker .speaker-name{
    font-size: 16px;
  }
  .workshop-speaker .speaker-org{
    font-size: 16px;
    color: #2c3e50;
  }
  .content-item .speaker-item .speaker-info{
    /*width: 300px;*/
    height: 120px;
    /*border: 1px solid red;*/
    text-align: left;
    display: flex;
    align-items:flex-end;
    position: relative;
    bottom: -40px;
  }
  .speaker-info .speaker-info-base{
    padding: 8px;
    padding-bottom: 40px;
  }
  .speaker-info .speaker-info-base .speaker-name{
    color: #0e5ca5;
    font-weight: 500;
  }
  /*.speaker-image{*/
    /*width: 120px;*/
    /*height: 100%;*/
  /*}*/
  .speaker-image{

    width: 140px;
    height: 140px;
    margin: 12px auto;
    background-size: cover;
    background-repeat: no-repeat;
    /*background-position: center;*/
    border-radius: 30px;
  }
  .speaker-image img{
    width: 100%;
    border: 1px solid #00a0e9;
  }
  .content-item .speaker-item .speaker-content{
    border: 1px solid #0e5ca5;
    padding: 16px;
  }
  .speaker-content .speaker-report-title{
    color: #303133;
    font-size: 20px;
    font-weight: 700;
    padding-top: 16px;
  }
  .speaker-content .speaker-report-content p{
    text-indent: 2em;
    text-align: justify;
  }
  .info-label{
		color: red;
		font-weight: 500;
	}
  .item-title-label{
    font-size: 12px;
    color: #2c3e50;
    padding-top: -10px;
    font-weight: normal;
  }
  .item-title-label a{
    font-size: 14px;

  }
  .item-content{
    margin-top: -30px;
  }
  .item-title-label .el-button--text{
    color: red;
		font-weight: 500;
  }
  .content-item .item-title{
    /* border: none;
    text-align: left; */
    text-align: center;
    border-top: 1px solid #0053a1;
    font-size: 24px;
    font-weight: bolder;
  }

  @media screen and (max-width: 800px){
    .content-item {
      margin: 30px auto;
      margin-bottom: 30px;
    }
    /*.program_banner{*/
      /*background-image: url("../../static/images/workshop_mobile_banner.jpg");*/
      /*background-size: cover;*/
      /*background-position:left;*/
    /*}*/
    .item-title-content{
      position: relative;
      /*top:-38px;*/
    }
    .item-content{
      margin-top: 0px;
    }

  }
  @media screen and (max-width: 410px){
    .workshop-speaker-contain{
      justify-content:center ;
    }
  }

  .workshop-schedule-overview{
    margin-top: 16px !important;
    text-align: left;
    padding: 0 8px 24px;
  }
  .schedule-overview-note{
    font-size: 14px;
    color: #606266;
    margin-bottom: 16px;
    line-height: 1.5;
  }
  .item-content-title{
    font-weight: bolder;
    font-size: 18px;
    margin-bottom: 8px;
    margin-top: 24px;
    color: #0053a1;
  }
  .text-black-border{
    font-weight: bold;
  }
  .parallel-hint{
    margin: 12px 0 8px;
    font-size: 15px;
  }
  .parallel-list{
    margin-bottom: 8px;
  }
  .parallel-item{
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px 12px;
    margin-bottom: 10px;
    background: #fafafa;
  }
  .parallel-name{
    font-weight: bold;
    color: #409EFF;
    margin-bottom: 6px;
  }
  .parallel-meta{
    font-size: 14px;
    line-height: 1.6;
    color: #303133;
  }

</style>



// WEBPACK FOOTER //
// src/components/Workshop.vue